export default "__VITE_ASSET__ef630f3c__"